var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { translate, useToastService } from '@lucidlink/uicore';
import { usePlugFilespaceClient } from '#query-hooks';
import { GuestLinkKeyFactory } from '../query-key-factories/GuestLinkKeyFactory';
export const useUpdateGuestLinkExpiration = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const { addToast } = useToastService();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationKey: GuestLinkKeyFactory.mutations({
            filespaceId,
            workspaceId,
        }),
        mutationFn: async (params) => plugFilespaceClient({
            action: (fsClient) => fsClient.guestLinksManagement().updateGuestLink(params),
            filespaceId,
            workspaceId,
        }),
        onError: () => {
            addToast({
                'data-testid': 'update-guest-link-expiration-error',
                kind: 'negative',
                content: {
                    message: translate('Failed to update guest link expiration'),
                },
            });
        },
        onSettled: (_data, _error, params) => {
            const pendingMutations = queryClient.isMutating({
                mutationKey: GuestLinkKeyFactory.mutations({
                    filespaceId,
                    workspaceId,
                }),
            });
            const listRefetch = queryClient.refetchQueries({
                queryKey: GuestLinkKeyFactory.list({
                    filespaceId,
                    workspaceId,
                }),
            });
            // Refetching `exact` while a later guest-link mutation is pending
            // would wipe its optimistic ACL state; the last one refetches it.
            if (pendingMutations > 1) {
                return listRefetch;
            }
            return Promise.all([
                listRefetch,
                queryClient.refetchQueries({
                    queryKey: GuestLinkKeyFactory.exact({
                        workspaceId,
                        filespaceId,
                        linkId: params.guestLinkId,
                    }),
                }),
            ]);
        },
        networkMode: 'always',
    });
    return mutation;
};
_react_refresh_temp_1(useUpdateGuestLinkExpiration, "KrM3mhTkTlZAjWS6DCmlJKC0EYA=", false, () => [usePlugFilespaceClient, useToastService, useQueryClient, useMutation]);
